import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search) => {
  return await GET(
    `/admin/rummy/points-rummy-history?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}`,
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/rummy/rummy-points/${id}`);
};

export const Create = async (data) => {
  return await POST(`/admin/rummy/rummy-points`, data);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/rummy/rummy-points/${id}`, data);
};

export const Status = async (id) => {
  return await POST(`/admin/rummy/rummy-points/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/rummy/rummy-points/${id}`);
};
